import { motion, AnimatePresence } from 'framer-motion'
import { CheckCircle2, Loader2, XCircle, Wrench } from 'lucide-react'
import type { ToolCallEvent } from '@/lib/supportApi'

const TOOL_LABELS: Record<string, string> = {
  kb_search: 'Base de conhecimento',
  kb: 'Base de conhecimento',
  hotmart_query: 'Hotmart',
  hotmart: 'Hotmart',
  lead_agent: 'Registro de lead',
  lead: 'Registro de lead',
  planner: 'Planejamento',
  octadesk_ticket: 'Criando ticket',
  ticket: 'Criando ticket',
  octadesk: 'Criando ticket',
}

interface ToolCallIndicatorProps {
  calls: ToolCallEvent[]
}

export function ToolCallIndicator({ calls }: ToolCallIndicatorProps) {
  if (calls.length === 0) return null

  return (
    <div className="ml-9 space-y-1">
      <AnimatePresence mode="popLayout">
        {calls.map((call, idx) => (
          <motion.div
            key={`${call.tool}-${idx}`}
            layout
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="flex items-center gap-2 text-xs"
          >
            {call.status === 'running' ? (
              <Loader2 className="h-3 w-3 text-primary animate-spin" />
            ) : call.status === 'done' ? (
              <CheckCircle2 className="h-3 w-3 text-emerald-500" />
            ) : (
              <XCircle className="h-3 w-3 text-destructive" />
            )}
            <Wrench className="h-3 w-3 text-muted-foreground" />
            <span className="text-muted-foreground">
              {TOOL_LABELS[call.tool] ?? call.tool}
            </span>
            {call.resultSummary && call.status !== 'running' && (
              <span className="text-foreground/80">
                — {call.resultSummary}
              </span>
            )}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  )
}
